import FirestoreDocument from "../../../types/FirestoreDocument";
import FirestoreLifecycle from "../../../types/FirestoreLifecycle";
import { boolean, string } from "../../../types/_types";

export const ProductionTodo = FirestoreDocument.extend({
	text: string(),
	resolved: boolean(),
}).merge(FirestoreLifecycle);
